import React from "react";
import { useHistory } from "react-router-dom";
import { Col, Dropdown, Menu, Row } from "antd";
import {
  UserOutlined,
  KeyOutlined,
  LogoutOutlined,
  CreditCardOutlined,
  GlobalOutlined,
} from "@ant-design/icons";

import { withAppContext } from "contexts/AppContext/AppContext";
import {
  buildBaseUri,
  buildProfileUri,
  buildResetPasswordUri,
  buildBillingUri,
} from "utils/routes";

import {
  AccountInfoMenuItem,
  AvatarButton,
  CompanyLogoCol,
  CompanyText,
  HeaderContainer,
  MenuItem,
  NameText,
} from "./Header.styles";

import Language from "components/Language/Language";
import Locale from "react-intl-universal";

const Header = ({
  username,
  companyName,
  companyLogo,
  firstName = "",
  lastName = "?",
  onLogout,
}) => {
  const history = useHistory();
  const getInitalsFromFullName = (firstName, lastName) => {
    return `${firstName ? firstName.charAt(0) : ""}${lastName.charAt(0)}`;
  };

  const handleOnMenuItemClick = (e) => {
    const uri = e.key;
    if (uri === buildBaseUri()) {
      onLogout();
    }
    if (uri === "accountInfo") {
      return;
    }
    history.push(uri);
  };

  const menu = (
    <Menu onClick={handleOnMenuItemClick}>
      <AccountInfoMenuItem key="accountInfo" style={{ cursor: "default" }}>
        <Row gutter={16} align="middle">
          <CompanyLogoCol companyLogo={companyLogo} />
          <Col style={{ maxWidth: "200px", marginLeft: "4px" }}>
            <NameText>
              {firstName}
              {lastName ? ` ${lastName}` : ""}
            </NameText>
            <br />
            {companyName && <CompanyText>{companyName}</CompanyText>}
          </Col>
        </Row>
      </AccountInfoMenuItem>
      <Menu.Divider />
      <MenuItem key={buildProfileUri()}>
        <UserOutlined />
        {Locale.get("dropDownHeader.profile")}
      </MenuItem>
      <Menu.Divider />
      <MenuItem key={buildBillingUri()}>
        <CreditCardOutlined />
        {Locale.get("dropDownHeader.billing")}
      </MenuItem>
      <Menu.Divider />
      <MenuItem key={buildResetPasswordUri()}>
        <KeyOutlined />
        {Locale.get("dropDownHeader.resetPassword")}
      </MenuItem>
      <Menu.Divider />
      {/* <MenuItem>
      <GlobalOutlined />
        Change Language
      </MenuItem> */}

      {/* <Language /> */}
      {/* <Menu.Divider /> */}

      <MenuItem key={buildBaseUri()}>
        <LogoutOutlined />
        {Locale.get("dropDownHeader.logOut")}
      </MenuItem>
    </Menu>
  );

  return (
    <HeaderContainer justify="end">
      <Dropdown overlay={menu} placement="bottomRight" trigger="click">
        <AvatarButton>
          {getInitalsFromFullName(firstName, lastName)}
        </AvatarButton>
      </Dropdown>
    </HeaderContainer>
  );
};

export default withAppContext(Header);
